import Model from '../models/model'

const model = new Model({
	name: 'EndoSetupHookupRapidAER',
	disableDelete: true,
	disableAdd: true,
	disableColumnSelector: true,
	disableFiltering: true,
	disableExport: true,
	readOnly: true,
	idProperty: '_id',
	pageSize: 1,
	showGridRefreshBtn: false,
	hideToolbar: true,
	disablePagination: true,
	defaultSort: 'MachineModel ASC',
	allowImport: false,
	columns: [
		{ header: 'HookupBlock', field: 'HookupValue', width: 120 },
		{ header: 'Channels', field: 'Channels', width: 140, align: 'right', headerAlign: 'right' },
		{ header: 'LeakTestChannels', field: 'ChannelsLeakTest', width: 150, align: 'right', headerAlign: 'right', type: 'number' }
	]
});

export const HookupDetailModel = model;
export default model.createGridBase();